import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Prism from 'prismjs';
import classNames from 'classnames';

import { Tooltip } from '@dsi/react-eds';

import './Example.css';

const Example = ({ code, language, fullwidth, expanded, children }) => {
  const codeRef = useRef();
  const [collapsed, setCollapsed] = useState(!expanded);
  const exampleSection = classNames('column', 'sm-12', {
    'xl-6': !fullwidth,
    'xl-12': fullwidth,
  });
  const codeSection = classNames('column', 'sm-12', {
    'xl-6': !fullwidth,
    'xl-12': fullwidth,
  });
  const codePreviewClasses = classNames('code-preview', { collapsed });
  const gradientClasses = classNames('gradient', {
    hidden: !collapsed,
  });

  useEffect(() => {
    Prism.highlightAll();
  }, []);

  useEffect(() => {
    if (codeRef.current.clientHeight < 150) {
      setCollapsed(false);
    }
  }, []);

  return (
    <div className="row">
      <div className={exampleSection}>
        {children && (
          <>
            <div className="section">Example</div>
            <div className="example-section">
              {children}
            </div>
          </>
        )}
      </div>
      <div className={codeSection}>
        <div className={codePreviewClasses}>
          <div className="code-actions">
            <div className="section">React</div>
            <Tooltip message={collapsed ? 'Expand code' : 'Collapse code'} position="left">
              <i className="icon icon-code" onClick={() => setCollapsed(!collapsed)} />
            </Tooltip>
          </div>
          <div className={gradientClasses} />
          <pre ref={codeRef} className={`language-${language}`}>
            <code className={`language-${language}`}>
              {code}
            </code>
          </pre>
        </div>
      </div>
    </div>
  );
};

Example.defaultProps = {
  code: '',
  language: 'html',
  fullwidth: false,
  expanded: false,
  children: null,
};

Example.propTypes = {
  code: PropTypes.string,
  language: PropTypes.string,
  fullwidth: PropTypes.bool,
  expanded: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default Example;
